// Load in vendor scripts;
// Only import the Bootstrap components whose data-api (data-bs-*) attributes are used in our markup.
// Popover is loaded on demand by ./js/popover. Add others here if new markup needs them.
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';

// Lazysizes
import 'lazysizes';
import 'lazysizes/plugins/native-loading/ls.native-loading';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// Load in custom JS modules required on initial page load

import('./js/viewport-size');

if (document.querySelector('body.site-layout') != null) {
    import('./js/scrolling');
    import('./js/keyboard-accessibility-check');
}

if (document.querySelector('#mega-menu') != null) {
    import('./js/mega-menu');
} else if (document.querySelector('#full-menu') != null) {
    import('./js/full-menu');
}

if (document.querySelector('#main-header--content--search-open-btn') != null) {
    import('./js/header-search');
}

if (document.querySelector('#top-message-bar.top-message-bar--dismissable') != null) {
    import('./js/top-message-bar');
}

if (document.querySelector('#promo-bar') != null) {
    import('./js/promo-bar');
}

// shopping basket
if (document.body.classList.contains('loop-commerce')) {
    if (document.querySelector('[data-loop-shopping-basket]') != null) {
        import('./js/commerce--shopping-basket-front-end');
    }
}

// lazyload font-awesome
let fa = document.createElement('script');
fa.type = 'text/javascript';
fa.src = 'https://kit.fontawesome.com/ac384d9989.js';
fa.crossOrigin = 'anonymous';
fa.defer = true;
fa.setAttribute('loading','lazy');
document.head.appendChild(fa);

// seasonal fx?
if (document.querySelector('body.snow-fx') != null) {
    import('./js/snow-fx.js');
}
if (document.querySelector('body.smoke-fx') != null) {
    import('./js/smoke-fx.js');
}
if (document.querySelector('body.fireworks-fx') != null) {
    import('./js/fireworks-fx.js');
}
if (document.querySelector('.cursor-sparkles') != null) {
    import('./js/cursor-sparkles.js');
}
if (document.querySelector('body.fireflies-fx') != null) {
    import('./js/fireflies-fx.js');
}
if (document.querySelector('body.bubbles-fx') != null) {
    import('./js/bubbles-fx.js');
}

// events-date-picker-form
if (document.querySelector('.events-date-picker-form') != null) {
    import('./js/events-date-picker-form');
}

// day planner
if (document.querySelector('#day-planner') != null) {
    import('./js/day-planner.js');
}

// visit planner
if (document.querySelector('#visit-planner') != null) {
    import('./js/visit-planner');
}

// Load in custom JS modules on initial page load and when DOM is updated

const addDataJsParsed = (elements, tag = '') => {
    elements.forEach(x => {
        x.setAttribute(`data-js-parsed--${tag}`, '');
    });
}

const quickCheckQueries = [];
let quickCheckQueryComplete = false,
    quickCheckQueryString = null;
const addQuickCheckQuery = (s) => {
    if(!quickCheckQueryComplete) {
        quickCheckQueries.push(s);
        quickCheckQueryString = quickCheckQueries.toString();
    }
};
const jsModuleQuickCheck = async () => {
    let checkQuery = document.querySelector(quickCheckQueryString);
    if (checkQuery != null) jsModuleCheck();
};

const moduleRegistry = [
    {
        // smart-bootstrap-tabs
        selector: '.nav[role="tablist"]:not([data-js-parsed--smart-bootstrap-tabs])',
        tag: 'smart-bootstrap-tabs',
        loader: () => import('./js/smart-bootstrap-tabs'),
    },
    {
        // defer-iframe-content
        selector: 'iframe.defer-iframe-content[data-src]:not([data-js-parsed--defer-iframe-content])',
        tag: 'defer-iframe-content',
        loader: () => import('./js/defer-iframe-content'),
    },
    {
        // btn-brand-primary size watcher
        selector: '.btn-brand-primary:not([data-js-parsed--size-watcher]), .btn-brand-primary-outline:not([data-js-parsed--size-watcher])',
        tag: 'size-watcher',
        loader: () => import('./js/size-watcher'),
    },
    {
        // hunt-watch
        selector: '.hunt-watch:not([data-js-parsed--hunt-watch])',
        tag: 'hunt-watch',
        loader: () => import('./js/hunt-watch'),
    },
    {
        // data-sizes-js-fix (fixes lazysizes issue)
        selector: '*[data-sizes-js-fix]:not([data-js-parsed--data-sizes-js-fix])',
        tag: 'data-sizes-js-fix',
        loader: () => import('./js/data-sizes-js-fix'),
    },
    {
        // heading fx
        selector: '.heading-fx[data-heading-fx]:not([data-js-parsed--heading-fx])',
        tag: 'heading-fx',
        loader: () => import('./js/heading-fx.js'),
    },
    {
        // content fx
        selector: '.content-fx[data-content-fx]:not([data-js-parsed--content-fx])',
        tag: 'content-fx',
        loader: () => import('./js/content-fx.js'),
    },
    {
        // better-than-native bootstrap carousel swipe detection
        selector: '.carousel:not([data-js-parsed--bs-carousel])',
        tag: 'bs-carousel',
        loader: () => import('./js/bootstrap-carousel-swipe'),
    },
    {
        // width-watcher
        selector: '*[data-width-watcher]:not([data-js-parsed--width-watcher])',
        tag: 'width-watcher',
        loader: () => import('./js/width-watcher'),
    },
    {
        // non-lazyload img-load-watcher
        selector: 'img.img-load-watcher:not([data-js-parsed--img-load-watcher])',
        tag: 'img-load-watcher',
        loader: () => import('./js/img-load-watcher'),
    },
    {
        // hero video - vimeo
        selector: '.hero--video.vimeo:not([data-js-parsed--vimeo])',
        tag: 'vimeo',
        loader: () => import('./js/hero-video-vimeo'),
    },
    {
        // hero video - youtube
        selector: '.hero--video.youtube:not([data-js-parsed--youtube])',
        tag: 'youtube',
        loader: () => import('./js/hero-video-youtube'),
    },
    {
        // hero video - ignite
        selector: '.hero--video.ignite:not([data-js-parsed--ignite])',
        tag: 'ignite',
        loader: () => import('./js/hero-video-ignite'),
    },
    {
        // list-carousel
        selector: '.list-carousel:not([data-js-parsed--list-carousel])',
        tag: 'list-carousel',
        loader: () => import('./js/list-carousel'),
    },
    {
        // height matching
        selector: '*[data-hm-group]:not([data-js-parsed--height-match])',
        tag: 'height-match',
        loader: () => import('./js/height-match'),
    },
    {
        // accordion open/close all
        selector: '.accordion--open-close-all:not([data-js-parsed--accordion-open-close-all])',
        tag: 'accordion-open-close-all',
        loader: () => import('./js/accordion-open-close-all'),
    },
    {
        // collapse - expand for desktop
        selector: '.expand-for-desktop:not([data-js-parsed--expand-for-desktop])',
        tag: 'expand-for-desktop',
        loader: () => import('./js/collapse-expand-for-desktop'),
    },
    {
        // lightboxes (PhotoSwipe v5 - galleries and single images)
        selector: '.lightbox-image:not([data-js-parsed--lightbox]), .image-gallery:not([data-js-parsed--lightbox])',
        tag: 'lightbox',
        loader: () => import('./js/lightboxes.js'),
    },
    {
        // lightwidget-instagram
        selector: '.lightwidget-instagram:not([data-js-parsed--lightwidget-instagram])',
        tag: 'lightwidget-instagram',
        loader: () => import('./js/lightwidget-instagram'),
    },
    {
        // media-gallery
        selector: '.media-gallery:not([data-js-parsed--media-gallery])',
        tag: 'media-gallery',
        loader: () => import('./js/media-gallery.js'),
    },
    {
        // testimonials-carousel
        selector: '.testimonials-carousel:not([data-js-parsed--testimonials-carousel])',
        tag: 'testimonials-carousel',
        loader: () => import('./js/testimonials-carousel.js'),
    },
    {
        // awards-carousel
        selector: '.awards-carousel:not([data-js-parsed--awards-carousel])',
        tag: 'awards-carousel',
        loader: () => import('./js/awards-carousel.js'),
    },
    {
        // panels-carousel
        selector: '.panels-carousel:not([data-js-parsed--panels-carousel])',
        tag: 'panels-carousel',
        loader: () => import('./js/panels-carousel.js'),
    },
    {
        // videos-carousel
        selector: '.videos-carousel:not([data-js-parsed--videos-carousel])',
        tag: 'videos-carousel',
        loader: () => import('./js/videos-carousel.js'),
    },
    {
        // panel-listing--masonry
        selector: '.panel-listing--masonry:not([data-js-parsed--panel-listing--masonry])',
        tag: 'panel-listing--masonry',
        loader: () => import('./js/panel-listing--masonry.js'),
    },
    {
        // marquee-scroller
        selector: '.marquee-scroller:not([data-js-parsed--marquee-scroller])',
        tag: 'marquee-scroller',
        loader: () => import('./js/marquee-scroller.js'),
    },
    {
        // responsive nav bar
        selector: '.responsive-nav-bar:not([data-js-parsed--responsive-nav-bar])',
        tag: 'responsive-nav-bar',
        loader: () => import('./js/responsive-nav-bar.js'),
    },
    {
        // opening times
        selector: '.opening-times:not([data-js-parsed--opening-times])',
        tag: 'opening-times',
        loader: () => import('./js/opening-times-calendar.js'),
    },
    {
        // filter listing
        selector: '.listing-live-filtering:not([data-js-parsed--listing-live-filtering])',
        tag: 'listing-live-filtering',
        loader: () => import('./js/listing-live-filtering.js'),
    },
    {
        // help search form
        selector: '.help-search-form:not([data-js-parsed--help-search-form])',
        tag: 'help-search-form',
        loader: () => import('./js/help-search-form'),
    },
    {
        // collections search form
        selector: '.collections-search-form:not([data-js-parsed--collections-search-form])',
        tag: 'collections-search-form',
        loader: () => import('./js/collections-search-form'),
    },
    {
        // filter-options - date-dropdown
        selector: '.filter-options--date-dropdown:not([data-js-parsed--filter-options-date-dropdown])',
        tag: 'filter-options-date-dropdown',
        loader: () => import('./js/filter-options-date-dropdown'),
    },
    {
        // feedback-widget
        selector: '.feedback-widget:not([data-js-parsed--feedback-widget])',
        tag: 'feedback-widget',
        loader: () => import('./js/feedback-widget'),
    },
    {
        // countdown
        selector: '.countdown:not([data-js-parsed--countdown])',
        tag: 'countdown',
        loader: () => import('./js/countdown.js'),
    },
    {
        // masonry-gallery
        selector: '.masonry-gallery:not([data-js-parsed--masonry-gallery])',
        tag: 'masonry-gallery',
        loader: () => import('./js/masonry-gallery.js'),
    },
    {
        // image-hover-zoom
        selector: '.image-hover-zoom:not([data-js-parsed--image-hover-zoom])',
        tag: 'image-hover-zoom',
        loader: () => import('./js/image-hover-zoom.js'),
    },
    {
        // image-masks
        selector: '[class*="img-mask--"]:not([data-js-parsed--image-masks])',
        tag: 'image-masks',
        loader: () => import('./js/image-masks.js'),
    },
    {
        // interactive-map
        selector: '.interactive-map:not([data-js-parsed--interactive-map])',
        tag: 'interactive-map',
        loader: () => import('./js/interactive-map.js'),
    },
    {
        // timeline
        selector: '.timeline:not([data-js-parsed--timeline])',
        tag: 'timeline',
        loader: () => import('./js/timeline.js'),
    },
    {
        // fixed-bg-video
        selector: '.fixed-bg-video:not([data-js-parsed--fixed-bg-video])',
        tag: 'fixed-bg-video',
        loader: () => import('./js/fixed-bg-video'),
    },
    {
        // bokeh-bg
        selector: '.bokeh-bg:not([data-js-parsed--bokeh-bg])',
        tag: 'bokeh-bg',
        loader: () => import('./js/bokeh-bg.js'),
    },
    {
        // starfield-bg
        selector: '.starfield-bg:not([data-js-parsed--starfield-bg])',
        tag: 'starfield-bg',
        loader: () => import('./js/starfield-bg.js'),
    },
    {
        // scroll-content
        selector: '.scroll-content:not([data-js-parsed--scroll-content])',
        tag: 'scroll-content',
        loader: () => import('./js/scroll-content'),
    },
    {
        // themed-modal
        selector: '.themed-modal:not([data-js-parsed--themed-modal])',
        tag: 'themed-modal',
        loader: () => import('./js/themed-modal.js'),
    },
    {
        // offers-grid
        selector: '.offers-grid:not([data-js-parsed--offers-grid])',
        tag: 'offers-grid',
        loader: () => import('./js/offers-grid.js'),
    },
    {
        // daily-events-panels-carousel
        selector: '.daily-events-panels-carousel:not([data-js-parsed--daily-events-panels-carousel])',
        tag: 'daily-events-panels-carousel',
        loader: () => import('./js/daily-events-panels-carousel.js'),
    },
    {
        // daily-events-table
        selector: '.daily-events-table:not([data-js-parsed--daily-events-table])',
        tag: 'daily-events-table',
        loader: () => import('./js/daily-events-table.js'),
    },
    {
        // background-crossfader
        selector: '.background-crossfader:not([data-js-parsed--background-crossfader])',
        tag: 'background-crossfader',
        loader: () => import('./js/background-crossfader.js'),
    },
    {
        // bootstrap popovers
        selector: '[data-bs-toggle="popover"]:not([data-js-parsed--popover])',
        tag: 'popover',
        loader: () => import('./js/popover'),
    },
    {
        // transport-timetable
        selector: '.transport-timetable:not([data-js-parsed--transport-timetable])',
        tag: 'transport-timetable',
        loader: () => import('./js/transport-timetable.js'),
    },
    {
        // datepicker-transport-timetable
        selector: '.datepicker-transport-timetable:not([data-js-parsed--datepicker-transport-timetable])',
        tag: 'datepicker-transport-timetable',
        loader: () => import('./js/datepicker-transport-timetable.js'),
    },
    {
        // calendar-transport-timetable
        selector: '.calendar-transport-timetable:not([data-js-parsed--calendar-transport-timetable])',
        tag: 'calendar-transport-timetable',
        loader: () => import('./js/calendar-transport-timetable.js'),
    },
    {
        // stats-section
        selector: '.stats-section:not([data-js-parsed--stats-section])',
        tag: 'stats-section',
        loader: () => import('./js/stats-section.js'),
    },
    {
        // boat-mooring-quote-form
        selector: '.boat-mooring-quote-form:not([data-js-parsed--boat-mooring-quote-form])',
        tag: 'boat-mooring-quote-form',
        loader: () => import('./js/boat-mooring-quote-form.js'),
    },
    {
        // overflow-scroll-watcher
        selector: '*[data-overflow-scroll-watcher]:not([data-js-parsed--overflow-scroll-watcher])',
        tag: 'overflow-scroll-watcher',
        loader: () => import('./js/overflow-scroll-watcher.js'),
    },
    {
        // tripadvisor icon
        selector: '.fa-tripadvisor',
        tag: null,
        loader: () => import('./js/tripadvisor-icon'),
    },
    {
        // tiktok icon
        selector: '.fa-tiktok',
        tag: null,
        loader: () => import('./js/tiktok-icon'),
    },
    {
        // password-checker
        selector: '[data-password-checker]:not([data-js-parsed--password-checker])',
        tag: 'password-checker',
        loader: () => import('./js/password-checker'),
    },
    {
        // order-history-table--year-filter
        selector: '.order-history:not([data-js-parsed--order-history])',
        tag: 'order-history',
        loader: () => import('./js/order-history.js'),
    },
    {
        // commerce - [data-loop-product-listing]
        selector: '[data-loop-product-listing]:not([data-js-parsed--loop-product-listing])',
        tag: 'loop-product-listing',
        loader: () => import('./js/commerce--product-listing.js'),
    },
    {
        // commerce - [data-loop-product]
        selector: '[data-loop-product]:not([data-js-parsed--loop-product])',
        tag: 'loop-product',
        loader: () => import('./js/commerce--product.js'),
    },
    {
        // commerce - [data-loop-product-panel]
        selector: '[data-loop-product-panel]:not([data-js-parsed--loop-product-panel])',
        tag: 'loop-product-panel',
        loader: () => import('./js/commerce--product-panel.js'),
    },
    {
        // commerce - .form-number-control
        selector: '.form-number-control:not(.readonly):not([data-js-parsed--form-number-control])',
        tag: 'form-number-control',
        loader: () => import('./js/commerce--form-number-control.js'),
    },
    {
        // commerce - radio-collapse-control
        selector: '.radio-collapse-control:not([data-js-parsed--radio-collapse-control])',
        tag: 'radio-collapse-control',
        loader: () => import('./js/commerce--radio-collapse-control.js'),
    },
    {
        // commerce - loop-gift-card
        selector: '[data-loop-gift-card]:not([data-js-parsed--loop-gift-card])',
        tag: 'loop-gift-card',
        loader: () => import('./js/commerce--gift-card.js'),
    },
    {
        // commerce - loop-subscription
        selector: '[data-loop-subscription]:not([data-js-parsed--loop-subscription])',
        tag: 'loop-subscription',
        loader: () => import('./js/commerce--subscription.js'),
    },
    {
        // commerce - booking-flow
        selector: '[data-loop-booking-flow]:not([data-js-parsed--loop-booking-flow])',
        tag: 'loop-booking-flow',
        loader: () => import('./js/commerce--booking-flow.js'),
    },
];

const jsModuleCheck = async () => {
    // find all required modules and start their downloads in parallel
    const pending = [];
    for (const mod of moduleRegistry) {
        addQuickCheckQuery(mod.selector);
        const elements = document.querySelectorAll(mod.selector);
        if (elements.length > 0) {
            if (mod.tag) addDataJsParsed(elements, mod.tag);
            pending.push({ elements, load: mod.loader() });
        }
    }
    quickCheckQueryComplete = true;
    // initialise in registry order (a failed module doesn't block the rest)
    for (const { elements, load } of pending) {
        try {
            const js = await load;
            if (js.createFrom) js.createFrom(elements);
        } catch (e) {
            console.error(e);
        }
    }
};

//// create a mutation observer to watch for dynamically added HTML

let checkRequested = false, checkTimeout = null;

// run a check on page load
jsModuleCheck();

const requestCheck = () => {
    if (!checkRequested) {
        checkRequested = true;
        clearTimeout(checkTimeout);
        checkTimeout = setTimeout(() => {
            jsModuleQuickCheck().then(() => {
                checkRequested = false;
            });
        }, 100);
    }
};

// Select the node that will be observed for mutations
const targetNode = document.querySelector('body');
if (targetNode != null) {
    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };
    // Callback function to execute when mutations are observed
    const callback = function (mutationsList) {
        let checkNeeded = false;
        for(let x = 0, l = mutationsList.length; x < l; x++) {
            let mutation = mutationsList[x];
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                checkNeeded = true;
                break
            }
        }
        if (checkNeeded) requestCheck();
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    setTimeout(() => {
        // do another check now
        requestCheck();
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }, 3000);
}

window.addEventListener('dynamicContentLoaded', () => {
    requestCheck();
});

// fix for Umbraco 'preview' mode not being responsive in Chrome DevTools
if(window.top != window.self) {
    let newMeta = document.createElement('meta');
    newMeta.setAttribute('name','viewport');
    newMeta.setAttribute('content','width=device-width, initial-scale=1, shrink-to-fit=no');
    window.top.document.head.appendChild(newMeta);
}
